"use client";

import React from "react";
import { motion } from "framer-motion";

import Image from "next/image";

const WhyAskLocal = () => {
  const items = [
    {
      id: 1,
      image: "/why/image-2.jpeg",
      title: "Transparent Numbers",
      description: "Understand your true costs and options upfront",
    },
    {
      id: 2,
      image: "/why/image-4.jpeg",
      title: "Vetted Professionals",
      description: "Work only with trusted local experts",
    },
    {
      id: 3,
      image: "/why/image-1.jpeg",
      title: "Streamlined Process",
      description: "Everything you need, all in one smart platform",
    },
    {
      id: 4,
      image: "/why/image-3.jpeg",
      title: "Accountability Every Step",
      description: "Your concierge ensures nothing falls through the cracks",
    },
  ];

  return (
    <section className="w-full bg-[#F9FAFB] py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        {/* --- Heading --- */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
          className="text-left mb-10 md:mb-12"
        >
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl judson-regular text-[#000000] mb-4 leading-tight">
            Built for you <br /> not sold to you.
          </h2>
          <p className="text-[#938E8E] inter-regular text-base md:text-lg ml-0 md:ml-2 max-w-2xl">
            AskLocal is a free consumer resource. You’re never pressured, sold,
            or steered based on hidden incentives. Our mission is simple:
            restore clarity, accountability, and trust to the real estate
            experience.
          </p>
        </motion.div>

        {/* --- Feature Grid --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-6 md:gap-x-14 mt-5 justify-items-center">
          {items.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: index * 0.2,
                ease: "easeOut",
              }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.03, y: -5 }}
              className="flex items-start gap-4 bg-[#FFFFFF] w-full sm:w-[90%] md:w-[588px] h-auto md:h-[170px] p-4 md:p-3 rounded-3xl hover:shadow-md transition-all duration-300"
            >
              <div className="flex gap-5 mt-2 md:mt-3">
                {/* Icon Box */}
                <motion.div
                  whileHover={{ rotate: 5, scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 250 }}
                  className="min-w-[100px] min-h-[100px] md:min-w-[140px] md:min-h-[125px]  rounded-2xl flex items-center justify-center"
                >
                  <Image
                    src={item.image}
                    alt={item.title}
                    width={100}
                    height={100}
                    className="object-contain"
                  />
                </motion.div>

                {/* Text Content */}
                <div className="text-left mt-2 md:mt-5">
                  <h3 className="text-xl sm:text-2xl md:text-[32px] inter-medium text-[#212227] mb-1 leading-snug">
                    {item.title}
                  </h3>
                  <p className="inter-regular text-[#525252] text-sm md:text-base ml-0.5">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyAskLocal;
